export default "__VITE_ASSET__DF9lw2Ze__"